/**
 * Generate Study Dialog - Step 1: Introduction
 *
 * Migrated from: lego/page/etmf/overview/generate-study/Step1.jsx
 *
 * Overview of the 6-step wizard process
 */

import React from 'react'
import { useServiceContext } from '../../../../root'

export function Step1() {
  const context = useServiceContext()
  const { translate } = context.service.filter

  return (
    <div className="step step1 fs12">
      <p className="cparagh">{translate('ETMF_GENERATE_TRIAL_STRCT_STEP1_INFO')}</p>
      <ul className="has-step-circle">
        <li>
          <span className="step-circle">1</span>
          <b>{translate('STEP_NO:', { NO: 1 })} </b>
          <b>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP3')}</b>
          <br />
          {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP3_DESC')}
        </li>
        <li>
          <span className="step-circle">2</span>
          <b>{translate('STEP_NO:', { NO: 2 })} </b>
          <b>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP4')}</b>
          <br />
          {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP4_DESC')}
        </li>
        <li>
          <span className="step-circle">3</span>
          <b>{translate('STEP_NO:', { NO: 3 })} </b>
          <b>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP_ENVIRONMENTS')}</b>
          <br />
          {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP_ENVIRONMENTS_DESC')}
        </li>
        <li>
          <span className="step-circle">4</span>
          <b>{translate('STEP_NO:', { NO: 4 })}</b>
          <b> {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP5')}</b>
          <br />
          {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP5_DESC')}
        </li>
        <li>
          <span className="step-circle">5</span>
          <b>{translate('STEP_NO:', { NO: 5 })}</b>
          <b> {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP6')}</b>
          <br />
          {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP6_DESC')}
        </li>
        <li className="mb10">
          <span className="step-circle">6</span>
          <b>{translate('STEP_NO:', { NO: 6 })}</b>
          <b> {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP7')}</b>
          <br />
          {translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP7_DESC')}
        </li>
      </ul>
    </div>
  )
}

export default Step1
